import { extend } from 'vee-validate';

extend('greaterOrEqualToZero', {
  validate: async (value) => value >= 0,
  message: 'Opakování musí být aspoň 0!'
});

export default {};
